<template>
  <div>
    <div v-if="$slots.empty && itemsWithKeys.length === 0">
      <slot name="empty" />
    </div>
    <div ref="reorderable-list" :data-key="listKey">
      <div
        v-for="(item, index) in itemsWithKeys"
        :key="item.reorderKey"
        :class="rowClass"
        :data-key="item.reorderKey"
      >
        <slot :item="item.item" :index="index" />
      </div>
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs'

import { mapModel } from '@/utils/computed'

export default {
  name: 'Reorderable',
  props: {
    /**
     * Group name for cross-container dragging
     */
    groupKey: { type: String, default: undefined },

    /**
     * Block key to be used for for-key
     * @default id
     */
    itemKey: { type: [String, Function], default: 'id' },

    /**
     * Key to be used for the list
     * @default id
     */
    listKey: { type: String, default: 'id' },

    /**
     * List of blocks
     * @model
     */
    modelValue: { type: Array, default: () => [] },

    /**
     * Class to add to row
     */
    rowClass: { type: String, default: undefined },
  },
  emits: ['reorder', 'update:modelValue'],
  computed: {
    ...mapModel('items'),
    itemsWithKeys() {
      const { items, itemKey } = this

      return items.map((item) => ({
        item,
        reorderKey:
          typeof itemKey === 'function' ? itemKey(item) : item[itemKey],
      }))
    },
  },
  mounted() {
    Sortable.create(this.$refs['reorderable-list'], {
      animation: 150,
      direction: 'vertical',
      filter: '.locked',
      group: this.groupKey,
      handle: '.drag-handle',
      onEnd: (event) => {
        if (event.oldIndex === event.newIndex && event.from === event.to) {
          return
        }

        this.$nextTick(() => {
          this.$emit('reorder', event)
        })
      },
      onMove: (evt) => {
        // Prevents disabled element from being moved
        return !evt.related.children[0]?.classList.contains('locked')
      },
    })
  },
}
</script>
